import type { StatusChipVariant } from '@/components/ui/status-chip';
import type { FxRecordStatus } from '@/services/api/fx-swaps';

const DEFAULT_MIN_FRACTION_DIGITS = 2;
const PRICE_MIN_FRACTION_DIGITS = 4;
const MAX_FRACTION_DIGITS = 8;

/** Table `amount` cell: min 2 / max 8 fraction digits. */
export const formatFxAmount = (value: number): string =>
  value.toLocaleString(undefined, { minimumFractionDigits: DEFAULT_MIN_FRACTION_DIGITS, maximumFractionDigits: MAX_FRACTION_DIGITS });

/** Price cells (customer/trade): nullish → 'N/A', else min 4 / max 8 fraction digits. */
export const formatFxPrice = (value: number | null | undefined): string =>
  value === null || value === undefined ? 'N/A' : value.toLocaleString(undefined, { minimumFractionDigits: PRICE_MIN_FRACTION_DIGITS, maximumFractionDigits: MAX_FRACTION_DIGITS });

/** Legacy formatNumber: nullish → 'N/A', else min 2 / max 8 fraction digits. */
export const formatFxNumber = (value: number | null | undefined): string => (value === null || value === undefined ? 'N/A' : formatFxAmount(value));

/**
 * Status → chip variant, shared by the table column and the detail dialog. Deliberate
 * fix for both legacy chip bugs: the table mapped FAILED to the literal
 * color name 'failed' (not a theme color → default chip) and the dialog's lowercase-
 * keyed map (pending/quoted/traded/failed) never matched the uppercase statuses —
 * both now render SUCCESS → green, FAILED → red.
 */
export const FX_STATUS_CHIP_VARIANTS: Record<FxRecordStatus, StatusChipVariant> = {
  SUCCESS: 'success',
  FAILED: 'destructive',
};
